/* global axios */
import ApiClient from './ApiClient';

// Painel de comissões SKY do consultor (cash-basis, escopado por user no backend).
class CommissionSkyDashboardApi extends ApiClient {
  constructor() {
    super('commission_sky_dashboard', { accountScoped: true });
  }

  show(params = {}) {
    return axios.get(this.url, { params });
  }
}

// Repasses semanais por consultor (admin).
class CommissionSkyPayoutsApi extends ApiClient {
  constructor() {
    super('commission_sky_payouts', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  markPaid(id) {
    return axios.post(`${this.url}/${id}/mark_paid`);
  }

  reopen(id) {
    return axios.post(`${this.url}/${id}/reopen`);
  }
}

// Parcelas de comissão (drill-down admin).
class CommissionSkyInstallmentsApi extends ApiClient {
  constructor() {
    super('commission_sky_installments', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }
}

export const commissionSkyDashboardApi = new CommissionSkyDashboardApi();
export const commissionSkyPayoutsApi = new CommissionSkyPayoutsApi();
export const commissionSkyInstallmentsApi = new CommissionSkyInstallmentsApi();
